/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { TableRecord } from '../models/TableRecord';

export class SchemaRecord {
  /**
  * name of the schema
  */
  'name': string;
  'tables'?: Array<TableRecord>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "tables",
      "baseName": "tables",
      "type": "Array<TableRecord>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SchemaRecord.attributeTypeMap;
  }

  public constructor() {
  }
}

